@let statement = statementSg();
@let depth = depthSg();

<div [class]="['statement', 'statement--depth-' + depth]">
  <div class="statement__content">
    <!-- Connector -->
    <div class="statement__connector-container">
      <div class="statement__connector-arm statement__connector-arm--top"></div>
      <div
        [class]="{
          statement__connector: true,
          'statement__connector--and': statement.connector === Connector.And,
          'statement__connector--or': statement.connector === Connector.Or,
        }"
        (click)="toggleConnector()"
        data-test-id="connector-statement"
      >
        {{ statement.connector }}
      </div>
      <div
        class="statement__connector-arm statement__connector-arm--bottom"
      ></div>
    </div>

    <!-- Filters -->
    <div class="statement__filter-container">
      <!-- TODO: fix drag and drop -->
      <!-- cdkDropList
    (cdkDropListDropped)="dropInFilter($event)"
    [id]="idSg()"
    [cdkDropListConnectedTo]="connectedToSg()"
    [cdkDropListData]="statement" -->

      <!-- Removed cdkDrag from the div under, should be returned after bugs regarding drag and drop are fixed.  -->
      <!-- cdkDrag -->
      <!-- [cdkDragData]="filter" -->
      <!-- [cdkDragDisabled]="isStatement(filter)" -->
      @for (filter of statement.filters; track $index) {
        <atn-rate-gl-filter
          [id]="store.createId({ index: $index, parentId: idSg() })"
          [filter]="filter"
          (filterChange)="overwriteFilter($index, $event)"
        />
      }
    </div>
  </div>

  <!-- Group adder -->
  @if (depth < maxDepth) {
    <div
      class="statement__group-adder"
      (click)="addGroup()"
    >
      <i class="atn-icon atn-plus atn-blue"></i>
      <p
        [class]="[
          'statement__group-adder-text',
          'statement__group-adder-text--depth-' + depth,
        ]"
      >
        Add {{ depth === 0 ? 'Group' : 'Inner Group' }}
      </p>
    </div>
  }
</div>
